const EN = {
  VA_BCA: {
    bank: "BCA",
    channels: [
      {
        name: "ATM",
        steps: [
          "Insert your BCA ATM card and enter your PIN",
          "Select Other Transaction",
          "Select Transfer",
          'Select "Transfer"',
          "Select To BCA Virtual Account",
          "Enter your Virtual Account Number [Number here], then select Correct",
          "Verify the payment details and enter the payment amount, then select Correct.",
          "Review the transaction details",
          "Select Yes to confirm the transaction.",
          "Your payment is complete. Select No to finish the transaction.",
        ],
      },
      {
        name: "KlikBCA (Internet Banking)",
        steps: [
          "Log in to your KlikBCA Individual account",
          "Go to Transfer → Transfer to BCA Virtual Account.",
          "Enter your Virtual Account Number [Number here]",
          "Click Continue",
          'Enter "RESPON KEYBCA APPLI 1" shown in your BCA Token, then click on the "Send" button',
          "Review the payment details, then click Send",
          "Enter the authentication code generated by your KeyBCA token",
          "Your payment has been completed successfully.",
          "Your invoice status will be updated automatically within 5 minutes",
        ],
      },
      {
        name: "BCA Mobile",
        steps: [
          "Open the BCA Mobile app",
          "Select m-BCA → m-Transfer",
          "Select BCA Virtual Account.",
          "Enter your Virtual Account Number [Number here], then tap OK.",
          "Review the payment details, then tap Send.",
          "Enter your m-BCA PIN to authorize the payment.",
          "Your payment has been completed successfully.",
          "Your invoice status will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_MANDIRI: {
    bank: "Mandiri",
    channels: [
      {
        name: "Livin by Mandiri",
        steps: [
          "Open the Livin' by Mandiri app and log in.",
          "Select Payments",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and enter your PIN to authorize the transaction",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your Mandiri ATM card and enter your PIN",
          "Select Pay/Buy.",
          "Select Multi Payment.",
          "Enter your Company Code, followed by your Virtual Account Number, then select Correct.",
          "Review the payment details displayed on the screen.",
          "If everything is correct, select Yes to continue.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "Mandiri Internet Banking",
        steps: [
          "Log in to Mandiri Internet Banking.",
          "Select Payment → Multi Payment",
          "Choose the billing provider, then enter your Virtual Account Number [number here]",
          "Review the payment details and click Continue.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_BNI: {
    bank: "BNI",
    channels: [
      {
        name: "wondr by BNI",
        steps: [
          "Open the wondr by BNI app and log in.",
          "Select Transfer.",
          "Tap Virtual Account Billing.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and enter your transaction PIN.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your BNI ATM card and enter your PIN.",
          "Select Other Transaction.",
          "Select Transfer.",
          "Select To BNI Virtual Account.",
          "Enter your Virtual Account Number [number here], then select Correct.",
          "Review the payment details and confirm the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "BNI Mobile Banking",
        steps: [
          "Open the BNI Mobile Banking app and log in.",
          "Select Transfer.",
          "Select Virtual Account Billing.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and enter your transaction PIN.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_BRI: {
    bank: "BRI",
    channels: [
      {
        name: "BRImo",
        steps: [
          "Open the BRImo app and log in.",
          "Select BRIVA.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and enter your PIN.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your BRI ATM card and enter your PIN.",
          "Select Other Transaction.",
          "Select Payment.",
          "Select BRIVA.",
          "Enter your Virtual Account Number [number here], then select Correct.",
          "Review the payment details and confirm the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes",
        ],
      },
      {
        name: "BRI Internet Banking",
        steps: [
          "Log in to BRI Internet Banking.",
          "Select Payment → BRIVA.",
          "Enter your Virtual Account Number [number here] and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes",
        ],
      },
    ],
  },
  VA_DANAMON: {
    bank: "Danamon",
    channels: [
      {
        name: "D-Bank PRO",
        steps: [
          "Open the D-Bank PRO app and log in.",
          "Select Payments.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction with your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your Danamon ATM card and enter your PIN.",
          "Select Payment.",
          "Select Virtual Account.",
          "Enter your Virtual Account Number [number here], then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes",
        ],
      },
      {
        name: "Danamon Internet Banking",
        steps: [
          "Log in to Danamon Internet Banking.",
          "Select Payments → Virtual Account.",
          "Enter your Virtual Account Number [number here] and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_MAYBANK: {
    bank: "Maybank",
    channels: [
      {
        name: "M2U ID App (Maybank2u)",
        steps: [
          "Open the M2U ID app and log in.",
          "Select Payments.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your Maybank ATM card and enter your PIN.",
          "Select Payment.",
          "Select Virtual Account.",
          "Enter your Virtual Account Number [number here], then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "Maybank Internet Banking",
        steps: [
          "Log in to Maybank2u Internet Banking.",
          "Select Payments.",
          "Choose Virtual Account.",
          "Enter your Virtual Account Number [number here] and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_PERMATA: {
    bank: "Permata",
    channels: [
      {
        name: "Permata ME",
        steps: [
          "Open the Permata ME app and log in.",
          "Select Pay & Transfer.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your Permata ATM card and enter your PIN.",
          "Select Payment.",
          "Select Virtual Account.",
          "Enter your Virtual Account Number [number here], then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "PermataNet",
        steps: [
          "Log in to PermataNet.",
          "Select Payment.",
          "Choose Virtual Account.",
          "Enter your Virtual Account Number [number here] and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_BSI: {
    bank: "BSI",
    channels: [
      {
        name: "BYOND by BSI",
        steps: [
          "Open the BYOND by BSI app and log in.",
          "Select Payments.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number [number here], then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your BSI ATM card and enter your PIN.",
          "Select Payment.",
          "Select Institution or Virtual Account.",
          "Enter your Virtual Account Number [number here], then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "BSI Net Banking",
        steps: [
          "Log in to BSI Net Banking.",
          "Select Payment.",
          "Choose Virtual Account.",
          "Enter your Virtual Account Number [number here] and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_OCBC: {
    bank: "OCBC",
    channels: [
      {
        name: "OCBC mobile",
        steps: [
          "Open the OCBC mobile app and log in.",
          "Select Transfer & Pay.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number, then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your OCBC ATM card and enter your PIN.",
          "Select Payment.",
          "Select Virtual Account.",
          "Enter your Virtual Account Number, then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "OCBC Internet Banking",
        steps: [
          "Log in to OCBC Internet Banking.",
          "Select Payments.",
          "Choose Virtual Account.",
          "Enter your Virtual Account Number and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_MUAMALAT: {
    bank: "Bank Muamalat",
    channels: [
      {
        name: "Muamalat DIN",
        steps: [
          "Open the Muamalat DIN app and log in.",
          "Select Payments.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number, then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your Muamalat ATM card and enter your PIN.",
          "Select Payment.",
          "Select Virtual Account.",
          "Enter your Virtual Account Number, then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "Muamalat Internet Banking",
        steps: [
          "Log in to Muamalat Internet Banking.",
          "Select Payments.",
          "Choose Virtual Account.",
          "Enter your Virtual Account Number and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_CIMB: {
    bank: "Bank CIMB Niaga",
    channels: [
      {
        name: "OCTO Mobile",
        steps: [
          "Open the OCTO Mobile app and log in.",
          "Select Pay Bills.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number, then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Insert your CIMB Niaga ATM card and enter your PIN.",
          "Select Payment.",
          "Select Virtual Account.",
          "Enter your Virtual Account Number, then select Continue.",
          "Review the payment details.",
          "Confirm the payment to complete the transaction.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
      {
        name: "OCTO Clicks",
        steps: [
          "Log in to OCTO Clicks.",
          "Select Payments.",
          "Choose Virtual Account.",
          "Enter your Virtual Account Number and click Continue.",
          "Review the payment details.",
          "Complete the authentication process to confirm the payment.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
  VA_BNC: {
    bank: "BNC",
    channels: [
      {
        name: "NEO+",
        steps: [
          "Open the Neo+ app and log in.",
          "Select Transfer & Pay.",
          "Tap Virtual Account.",
          "Enter your Virtual Account Number, then tap Continue.",
          "Review the payment details.",
          "Confirm the payment and authorize the transaction using your PIN or biometric authentication.",
          "Your payment has been completed successfully.",
          "Your invoice will be updated automatically within 5 minutes.",
        ],
      },
    ],
  },
};

const ID = {
  VA_BCA: {
    bank: "BCA",
    channels: [
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM BCA Anda dan masukkan PIN",
          "Pilih Transaksi Lainnya",
          "Pilih Transfer",
          'Pilih "Transfer"',
          "Pilih Ke Rek BCA Virtual Account",
          "Masukkan Nomor Virtual Account Anda [Nomor di sini], lalu pilih Benar",
          "Periksa detail pembayaran dan masukkan jumlah pembayaran, lalu pilih Benar.",
          "Periksa detail transaksi",
          "Pilih Ya untuk mengonfirmasi transaksi.",
          "Pembayaran Anda selesai. Pilih Tidak untuk mengakhiri transaksi.",
        ],
      },
      {
        name: "KlikBCA (Internet Banking)",
        steps: [
          "Masuk ke akun KlikBCA Individual Anda",
          "Buka Transfer → Transfer ke BCA Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [Nomor di sini]",
          "Klik Lanjutkan",
          'Masukkan "RESPON KEYBCA APPLI 1" yang muncul di BCA Token Anda, lalu klik tombol "Kirim"',
          "Periksa detail pembayaran, lalu klik Kirim",
          "Masukkan kode autentikasi yang dihasilkan oleh KeyBCA token Anda",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Status invoice Anda akan diperbarui secara otomatis dalam 5 menit",
        ],
      },
      {
        name: "BCA Mobile",
        steps: [
          "Buka aplikasi BCA mobile",
          "Pilih m-BCA → m-Transfer",
          "Pilih BCA Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [Nomor di sini], lalu ketuk OK.",
          "Periksa detail pembayaran, lalu ketuk Kirim.",
          "Masukkan PIN m-BCA Anda untuk mengotorisasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Status invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_MANDIRI: {
    bank: "Mandiri",
    channels: [
      {
        name: "Livin by Mandiri",
        steps: [
          "Buka aplikasi Livin' by Mandiri dan masuk ke akun Anda.",
          "Pilih Pembayaran",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan masukkan PIN Anda untuk mengotorisasi transaksi",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM Mandiri Anda dan masukkan PIN",
          "Pilih Bayar/Beli.",
          "Pilih Multi Payment.",
          "Masukkan Kode Perusahaan, diikuti dengan Nomor Virtual Account Anda, lalu pilih Benar.",
          "Periksa detail pembayaran yang ditampilkan di layar.",
          "Jika sudah benar, pilih Ya untuk melanjutkan.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "Mandiri Internet Banking",
        steps: [
          "Masuk ke Mandiri Internet Banking.",
          "Pilih Pembayaran → Multi Payment",
          "Pilih penyedia tagihan, lalu masukkan Nomor Virtual Account Anda [nomor di sini]",
          "Periksa detail pembayaran dan klik Lanjutkan.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_BNI: {
    bank: "BNI",
    channels: [
      {
        name: "wondr by BNI",
        steps: [
          "Buka aplikasi wondr by BNI dan masuk ke akun Anda.",
          "Pilih Transfer.",
          "Ketuk Virtual Account Billing.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan masukkan PIN transaksi Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM BNI Anda dan masukkan PIN.",
          "Pilih Transaksi Lainnya.",
          "Pilih Transfer.",
          "Pilih Ke Rek BNI Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu pilih Benar.",
          "Periksa detail pembayaran dan konfirmasi transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "BNI Mobile Banking",
        steps: [
          "Buka aplikasi BNI Mobile Banking dan masuk ke akun Anda.",
          "Pilih Transfer.",
          "Pilih Virtual Account Billing.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan masukkan PIN transaksi Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_BRI: {
    bank: "BRI",
    channels: [
      {
        name: "BRImo",
        steps: [
          "Buka aplikasi BRImo dan masuk ke akun Anda.",
          "Pilih BRIVA.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan masukkan PIN Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM BRI Anda dan masukkan PIN.",
          "Pilih Transaksi Lainnya.",
          "Pilih Pembayaran.",
          "Pilih BRIVA.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu pilih Benar.",
          "Periksa detail pembayaran dan konfirmasi transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit",
        ],
      },
      {
        name: "BRI Internet Banking",
        steps: [
          "Masuk ke BRI Internet Banking.",
          "Pilih Pembayaran → BRIVA.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini] dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit",
        ],
      },
    ],
  },
  VA_DANAMON: {
    bank: "Danamon",
    channels: [
      {
        name: "D-Bank PRO",
        steps: [
          "Buka aplikasi D-Bank PRO dan masuk ke akun Anda.",
          "Pilih Pembayaran.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi dengan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM Danamon Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit",
        ],
      },
      {
        name: "Danamon Internet Banking",
        steps: [
          "Masuk ke Danamon Internet Banking.",
          "Pilih Pembayaran → Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini] dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_MAYBANK: {
    bank: "Maybank",
    channels: [
      {
        name: "M2U ID App (Maybank2u)",
        steps: [
          "Buka aplikasi M2U ID dan masuk ke akun Anda.",
          "Pilih Pembayaran.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM Maybank Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "Maybank Internet Banking",
        steps: [
          "Masuk ke Maybank2u Internet Banking.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini] dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_PERMATA: {
    bank: "Permata",
    channels: [
      {
        name: "Permata ME",
        steps: [
          "Buka aplikasi PermataMe dan masuk ke akun Anda.",
          "Pilih Bayar & Transfer.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM Permata Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "PermataNet",
        steps: [
          "Masuk ke PermataNet.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini] dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_BSI: {
    bank: "BSI",
    channels: [
      {
        name: "BYOND by BSI",
        steps: [
          "Buka aplikasi BYOND by BSI dan masuk ke akun Anda.",
          "Pilih Pembayaran.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM BSI Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Institusi atau Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini], lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "BSI Net Banking",
        steps: [
          "Masuk ke BSI Net Banking.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda [nomor di sini] dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_OCBC: {
    bank: "OCBC",
    channels: [
      {
        name: "OCBC mobile",
        steps: [
          "Buka aplikasi OCBC mobile dan masuk ke akun Anda.",
          "Pilih Transfer & Pay.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM OCBC Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "OCBC Internet Banking",
        steps: [
          "Masuk ke OCBC Internet Banking.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_MUAMALAT: {
    bank: "Bank Muamalat",
    channels: [
      {
        name: "Muamalat DIN",
        steps: [
          "Buka aplikasi Muamalat DIN dan masuk ke akun Anda.",
          "Pilih Pembayaran.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM Muamalat Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "Muamalat Internet Banking",
        steps: [
          "Masuk ke Muamalat Internet Banking.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_CIMB: {
    bank: "Bank CIMB Niaga",
    channels: [
      {
        name: "OCTO Mobile",
        steps: [
          "Buka aplikasi OCTO Mobile dan masuk ke akun Anda.",
          "Pilih Bayar Tagihan.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "ATM",
        steps: [
          "Masukkan kartu ATM CIMB Niaga Anda dan masukkan PIN.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu pilih Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran untuk menyelesaikan transaksi.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
      {
        name: "OCTO Clicks",
        steps: [
          "Masuk ke OCTO Clicks.",
          "Pilih Pembayaran.",
          "Pilih Virtual Account.",
          "Masukkan Nomor Virtual Account Anda dan klik Lanjutkan.",
          "Periksa detail pembayaran.",
          "Selesaikan proses autentikasi untuk mengonfirmasi pembayaran.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
  VA_BNC: {
    bank: "BNC",
    channels: [
      {
        name: "NEO+",
        steps: [
          "Buka aplikasi Neo+ dan masuk ke akun Anda.",
          "Pilih Transfer & Pay.",
          "Ketuk Virtual Account.",
          "Masukkan Nomor Virtual Account Anda, lalu ketuk Lanjutkan.",
          "Periksa detail pembayaran.",
          "Konfirmasi pembayaran dan otorisasi transaksi menggunakan PIN atau autentikasi biometrik Anda.",
          "Pembayaran Anda telah berhasil diselesaikan.",
          "Invoice Anda akan diperbarui secara otomatis dalam 5 menit.",
        ],
      },
    ],
  },
};

const ZH = {
  VA_BCA: {
    bank: "BCA",
    channels: [
      {
        name: "ATM",
        steps: [
          "插入您的 BCA ATM 卡并输入 PIN 码",
          "选择「其他交易」",
          "选择「转账」",
          "选择「转账」",
          "选择「转至 BCA 虚拟账户」",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「正确」",
          "核对付款详情并输入付款金额，然后选择「正确」。",
          "核对交易详情",
          "选择「是」以确认交易。",
          "付款已完成。选择「否」结束交易。",
        ],
      },
      {
        name: "KlikBCA (Internet Banking)",
        steps: [
          "登录您的 KlikBCA Individual 账户",
          "进入「转账」→「转至 BCA 虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]",
          "点击「继续」",
          "在 BCA Token 上输入显示的「RESPON KEYBCA APPLI 1」，然后点击「发送」按钮",
          "核对付款详情，然后点击「发送」",
          "输入您的 KeyBCA token 生成的验证码",
          "您的付款已成功完成。",
          "您的账单状态将在 5 分钟内自动更新",
        ],
      },
      {
        name: "BCA Mobile",
        steps: [
          "打开 BCA mobile 应用",
          "选择 m-BCA → m-Transfer",
          "选择「BCA 虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「确定」。",
          "核对付款详情，然后点击「发送」。",
          "输入您的 m-BCA PIN 码以授权付款。",
          "您的付款已成功完成。",
          "您的账单状态将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_MANDIRI: {
    bank: "Mandiri",
    channels: [
      {
        name: "Livin by Mandiri",
        steps: [
          "打开 Livin' by Mandiri 应用并登录。",
          "选择「支付」",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款并输入 PIN 码以授权交易",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 Mandiri ATM 卡并输入 PIN 码",
          "选择「支付/购买」。",
          "选择「Multi Payment」。",
          "输入您的公司代码，接着输入虚拟账户号码，然后选择「正确」。",
          "核对屏幕上显示的付款详情。",
          "确认无误后，选择「是」继续。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "Mandiri Internet Banking",
        steps: [
          "登录 Mandiri 网上银行。",
          "选择「支付」→「Multi Payment」",
          "选择账单提供商，然后输入您的虚拟账户号码 [此处填写号码]",
          "核对付款详情并点击「继续」。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_BNI: {
    bank: "BNI",
    channels: [
      {
        name: "wondr by BNI",
        steps: [
          "打开 wondr by BNI 应用并登录。",
          "选择「转账」。",
          "点击「Virtual Account Billing」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款并输入您的交易 PIN 码。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 BNI ATM 卡并输入 PIN 码。",
          "选择「其他交易」。",
          "选择「转账」。",
          "选择「转至 BNI 虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「正确」。",
          "核对付款详情并确认交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "BNI Mobile Banking",
        steps: [
          "打开 BNI Mobile Banking 应用并登录。",
          "选择「转账」。",
          "选择「Virtual Account Billing」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款并输入您的交易 PIN 码。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_BRI: {
    bank: "BRI",
    channels: [
      {
        name: "BRImo",
        steps: [
          "打开 BRImo 应用并登录。",
          "选择「BRIVA」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款并输入您的 PIN 码。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 BRI ATM 卡并输入 PIN 码。",
          "选择「其他交易」。",
          "选择「支付」。",
          "选择「BRIVA」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「正确」。",
          "核对付款详情并确认交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新",
        ],
      },
      {
        name: "BRI Internet Banking",
        steps: [
          "登录 BRI 网上银行。",
          "选择「支付」→「BRIVA」。",
          "输入您的虚拟账户号码 [此处填写号码] 并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新",
        ],
      },
    ],
  },
  VA_DANAMON: {
    bank: "Danamon",
    channels: [
      {
        name: "D-Bank PRO",
        steps: [
          "打开 D-Bank PRO 应用并登录。",
          "选择「支付」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 Danamon ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新",
        ],
      },
      {
        name: "Danamon Internet Banking",
        steps: [
          "登录 Danamon 网上银行。",
          "选择「支付」→「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码] 并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_MAYBANK: {
    bank: "Maybank",
    channels: [
      {
        name: "M2U ID App (Maybank2u)",
        steps: [
          "打开 M2U ID 应用并登录。",
          "选择「支付」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 Maybank ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "Maybank Internet Banking",
        steps: [
          "登录 Maybank2u 网上银行。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码] 并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_PERMATA: {
    bank: "Permata",
    channels: [
      {
        name: "Permata ME",
        steps: [
          "打开 Permata ME 应用并登录。",
          "选择「支付与转账」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 Permata ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "PermataNet",
        steps: [
          "登录 PermataNet。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码] 并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_BSI: {
    bank: "BSI",
    channels: [
      {
        name: "BYOND by BSI",
        steps: [
          "打开 BYOND by BSI 应用并登录。",
          "选择「支付」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 BSI ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「机构」或「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码]，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "BSI Net Banking",
        steps: [
          "登录 BSI Net Banking。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码 [此处填写号码] 并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_OCBC: {
    bank: "OCBC",
    channels: [
      {
        name: "OCBC mobile",
        steps: [
          "打开 OCBC mobile 应用并登录。",
          "选择「转账与支付」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 OCBC ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "OCBC Internet Banking",
        steps: [
          "登录 OCBC 网上银行。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_MUAMALAT: {
    bank: "Bank Muamalat",
    channels: [
      {
        name: "Muamalat DIN",
        steps: [
          "打开 Muamalat DIN 应用并登录。",
          "选择「支付」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 Muamalat ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "Muamalat Internet Banking",
        steps: [
          "登录 Muamalat 网上银行。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_CIMB: {
    bank: "Bank CIMB Niaga",
    channels: [
      {
        name: "OCTO Mobile",
        steps: [
          "打开 OCTO Mobile 应用并登录。",
          "选择「缴费」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "ATM",
        steps: [
          "插入您的 CIMB Niaga ATM 卡并输入 PIN 码。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码，然后选择「继续」。",
          "核对付款详情。",
          "确认付款以完成交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
      {
        name: "OCTO Clicks",
        steps: [
          "登录 OCTO Clicks。",
          "选择「支付」。",
          "选择「虚拟账户」。",
          "输入您的虚拟账户号码并点击「继续」。",
          "核对付款详情。",
          "完成验证流程以确认付款。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
  VA_BNC: {
    bank: "BNC",
    channels: [
      {
        name: "NEO+",
        steps: [
          "打开 Neo+ 应用并登录。",
          "选择「转账与支付」。",
          "点击「虚拟账户」。",
          "输入您的虚拟账户号码，然后点击「继续」。",
          "核对付款详情。",
          "确认付款，并使用 PIN 码或生物识别验证授权交易。",
          "您的付款已成功完成。",
          "您的账单将在 5 分钟内自动更新。",
        ],
      },
    ],
  },
};

const VIRTUAL_ACCOUNT_INSTRUCTIONS_BY_LOCALE = { en: EN, id: ID, zh: ZH };

export const getVirtualAccountInstructions = (language) =>
  VIRTUAL_ACCOUNT_INSTRUCTIONS_BY_LOCALE[language] || VIRTUAL_ACCOUNT_INSTRUCTIONS_BY_LOCALE.en;
